import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveCity } from '../../shared/components';

export type CreateCityPageProps = {};

const CreateCityPage: React.FC<CreateCityPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_ciudad);

  return <SaveCity titlePage="Crear Ciudad" />;
};

export default CreateCityPage;
